import React, { forwardRef } from 'react';

import { TrashcanIcon } from 'src/components/icons/TrashcanIcon';
import { useEditorTabStateSelector } from 'src/editor/editor-tab-state-registry';
import { BaseMenuOption } from 'src/editor/toolbars/menus/BaseMenuOption';
import type { CommonMenuItemProps } from 'src/editor/toolbars/menus/types';
import { ClientTransforms } from 'src/editor/transforms';
import { useCurrentUserId } from 'src/gql';
import { useAuthorizedTransforms } from 'src/hooks';
import { useEditor } from 'src/layout-engine';

/**
 * @deprecated Once the context menu is using DeclarativeMenu, remove this and refactor out the
 * relevant menu item configs from useEditMenu instead.
 */
export const DeleteMenuItem = forwardRef(function DeleteMenuItem(
  props: CommonMenuItemProps,
  ref: React.Ref<HTMLLIElement>
): JSX.Element {
  const { closeRootMenu, ...rest } = props;

  const editor = useEditor();
  const currentUserId = useCurrentUserId();
  const { AuthorizedTransforms } = useAuthorizedTransforms();
  const editingMode = useEditorTabStateSelector(state => state.documentUi.editingMode);

  function handleDelete(): void {
    if (!currentUserId || !editingMode) return;

    AuthorizedTransforms.deleteContent(editor, {
      authorId: currentUserId,
      direction: 'backward',
      editingMode,
    });

    closeRootMenu();

    ClientTransforms.focus(editor);
  }

  return (
    <BaseMenuOption
      ref={ref}
      icon={<TrashcanIcon />}
      label="Delete"
      onClick={handleDelete}
      {...rest}
    />
  );
});
